import React from 'react'
import ExpandableCard from '../../../../../../../components/Card/ExpandableCard'
import * as S from './styles'

const StatusDetailCard = ({ statusData }) => {
  const { label, schedulings, overbooks, total, icon, desc } = statusData
  const totalByType = {
    schedulings: schedulings.professional.total + schedulings.freelancer.total,
    overbooks: overbooks.professional.total + overbooks.freelancer.total
  }

  const cardInfo = {
    icon,
    title: label,
    subtitle: `${total} ${total === 1 ? 'atendimento' : 'atendimentos'} ${desc}`
  }

  const maxData = Math.max(...Object.values(totalByType))
  return (
    <ExpandableCard {...cardInfo}>
      <S.DetailedInfo>
        <hr />
        <S.Label value={totalByType.schedulings} maxData={maxData}>
          {totalByType.schedulings} {totalByType.schedulings === 1 ? 'Agendamento' : 'Agendamentos'}
        </S.Label>
        <S.Content>
          <strong>{schedulings.professional.total} </strong>
          {schedulings.professional.textInfo} profissional
          <strong> principal</strong>
        </S.Content>
        <S.Content>
          <strong>{schedulings.freelancer.total} </strong>
          {schedulings.freelancer.textInfo} profissionais
          <strong> substitutos</strong>
        </S.Content>
        <hr />
        <S.Label value={totalByType.overbooks} maxData={maxData}>
          {totalByType.overbooks} {totalByType.overbooks === 1 ? 'Encaixe' : 'Encaixes'}
        </S.Label>
        <S.Content>
          <strong>{overbooks.professional.total} </strong>
          {overbooks.professional.textInfo} profissional
          <strong> principal</strong>
        </S.Content>
        <S.Content>
          <strong>{overbooks.freelancer.total} </strong>
          {overbooks.freelancer.textInfo} profissionais
          <strong> substitutos</strong>
        </S.Content>
      </S.DetailedInfo>
    </ExpandableCard>
  )
}

export default StatusDetailCard
